<template>
    <v-container fluid class="pa-0">
    <v-card>
        <v-card-title>
            {{$t('event.flight')}}
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddFlight">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :loading="isFlightsPending"
                @pagination="currentPagination"
                :items="tableFlights"
                >
                <template v-slot:item.name="{value}">
                    {{value}}
                </template>
                <template v-slot:item.scroller="{value}">
                    <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                    <div v-show="!isEditOrderMode"></div>
                </template>
                <template v-slot:item.items="{item,value}">
                    {{getLength(item)}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode"
                        @click="initEditFlight(item)">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                        @click="deleteFlight(item)">
                        {{$t('delete')}}
                        <v-icon right>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>

        <v-dialog v-model="showEditFlightDialog"
            persistent
            fullscreen
            hide-overlay
            >
            <v-card id="vCard">
                <v-app-bar fixed dark color="primary">
                    <v-btn icon dark @click="closeEditFlight">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span class="app-bar">{{$t('event.flight')}}</span>
                </v-app-bar>
                <v-container class="pt-16">
                    <v-row>
                        <v-col class="py-0 mt-5">
                            <v-text-field outlined
                                        :label="$t('event_flight.name')"
                                        :placeholder="$t('event_flight.name')"
                                        v-model="editingFlightItem.name"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0 mt-5">
                            <v-text-field outlined
                                        :label="$t('event_flight.key')"
                                        :placeholder="$t('event_flight.key')"
                                        v-model="editingFlightItem.key"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="justify-end">
                        <v-label v-if="!selectedFlightId">
                            {{'Click save to start adding Flight items'}}
                        </v-label>
                        <div class="saveFlightEditButton"></div>
                        <v-btn color="primary" @click="saveFlightEdit">
                            {{$t('save')}}
                        </v-btn>
                        <div class="saveFlightEditButton"></div>
                    </v-row>
                    <v-row v-if="editingFlightItem && selectedFlightId">
                        <v-col>
                            <EventFlightItemList :flight-id="editingFlightItem.id"></EventFlightItemList>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
    </v-container>
</template>
<style scoped>
    .saveFlightEditButton {
        width:12px;
        height: 50px;
    }
    .button-spacer {
        width:10px;
    }

    .app-bar {
        font-size: 1.25rem; 
        line-height: 1.5; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        margin-left: 20px;
    }

</style>
<script>
    import {computed, ref, watch, onMounted} from '@vue/composition-api'
    import {useGet, useFind} from "feathers-vuex";
    import EventFlightItemList from "./EventFlightItemList";
    import { cloneDeep,differenceWith, difference } from 'lodash';
    import Sortable from "sortablejs";

    export default {
        name: 'EventFlight',
        components: {EventFlightItemList},
        setup(props, {root}) {
            const {Event,EventFlight} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);

            const {item: event, isPending} = useGet({model: Event, id: eventId.value});
            
            const flightParams = computed(()=>{
                return {
                    query:{
                        eventId: eventId.value
                    },
                    $sort:{
                        order: 1
                    }
                }
            })
            const {items: flights, isPending: isFlightsPending} = useFind({
                model: EventFlight,
                params: flightParams,
            })
            
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);
            const editOrderFlights = ref([]);
            const selectedFlightId=ref(null);

            const overlay = ref(false);

            const closeEditFlight = function() {
                showEditFlightDialog.value = false;
                selectedFlightId.value = null
            }
            const headers = ref([
                {text: '',value:'scroller',width:80},
                {text: 'Order',value:'order'},
                {text: 'Name',value:'name'},
                {text: 'Flight Items',value:'items'},
                {text: '',value:'actions'},
            ])

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };

            const editingFlightItem = ref(new EventFlight({eventId: eventId.value}))
            const showEditFlightDialog = ref(false);

            const initEditFlight = function(flight){
                editingFlightItem.value = flight
                showEditFlightDialog.value = true
                selectedFlightId.value = flight.id
            }
            const initAddFlight = function(){
                showEditFlightDialog.value = true
                editingFlightItem.value = new EventFlight({eventId: eventId.value})
                selectedFlightId.value = null
                console.log(flights.value);
                editingFlightItem.value.order = flights.value.length + 1;
            }

            const deleteFlight = function(item){
                if(confirm(root.$t('event_flight.confirm_delete'))){
                    item.remove().then(()=>{
                        root.$store.dispatch('showSnackBar', root.$t('event_flight.delete_successful'));
                    }, root.$handleFeatherError.bind(root));
                }
            }
            const getLength = function(item){
                return item?(item.items?item.items.length:0):0
            }

            const saveFlightEdit = async function(){
                editingFlightItem.value.save().then(async (savedFlight)=>{
                    editingFlightItem.value = savedFlight
                    selectedFlightId.value = savedFlight.id
                    root.$store.dispatch('showSnackBar', root.$t('event_flight.save_successful'));
                })

            }
            const initEditOrder = function(){
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderFlights.value = cloneDeep(sortedFlights.value)
            }

            const saveEditOrder =  async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                for(let i=0;i<editOrderFlights.value.length;i++){
                    await editOrderFlights.value[i].save().then(()=>{
                        EventFlight.get(editOrderFlights.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false;
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false
            }
            const quickSortFlights = function(sortFlights){
                if(sortFlights.length<2){
                    return sortFlights
                }

                const chosenIndex = sortFlights.length - 1
                const chosen  = sortFlights[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortFlights[i].order
                    temp < chosen.order ? a.push(sortFlights[i]) : b.push(sortFlights[i])
                }
                const output = [...quickSortFlights(a),chosen,...quickSortFlights(b)]
                return output
            }

            const sortedFlights = computed(()=>{
                return quickSortFlights(flights.value)
            })
            const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            didOrderChange.value = true;
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderFlights.value.splice(oldIndex,1)[0];
                            editOrderFlights.value.splice(newIndex,0,rowSelected);

                            for(let i=0;i<editOrderFlights.value.length;i++){
                                editOrderFlights.value[i].order = i+1
                            }
                            editOrderFlights.value = quickSortFlights(editOrderFlights.value);
                        }
                    }
                )
            });

            watch(showEditFlightDialog, (newVal, oldVal) => {
                if (newVal) {
                    document.getElementById('vCard').scrollIntoView();
                }
            })

            const tableFlights = computed(()=>{
                return isEditOrderMode.value ? editOrderFlights.value : sortedFlights.value
            })

            return {
                headers,
                tableFlights,
                isFlightsPending,
                previewHtmlContentOption,
                isEditOrderMode,
                currentPagination,

                editingFlightItem,
                showEditFlightDialog,
                closeEditFlight,
                initEditFlight,
                initAddFlight,
                selectedFlightId,

                deleteFlight,
                getLength,
                saveFlightEdit,

                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                overlay,
            }
        },
    }
</script>